/* eslint-disable react-hooks/rules-of-hooks */
import { useState, useEffect } from 'react';

const useScreenSize = (): 'mobile' | 'desktop' | null => {
  if (typeof window === 'undefined') return null;

  const [width, setWidth] = useState<number>(window.innerWidth);

  const [isMobile, setIsMobile] = useState<'mobile' | 'desktop' | null>(null);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    setIsMobile(width < 800 ? 'mobile' : 'desktop');
  }, [width]);

  return isMobile;
};

export default useScreenSize;
